// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2WrQp","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3KsHZ"};